<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-stopwatch`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M29 4a1 1 0 00-1-1h-8a1 1 0 00-1 1v2a1 1 0 001 1h8a1 1 0 001-1V4zm14 24c0-10.493-8.507-19-19-19S5 17.507 5 28s8.507 19 19 19 19-8.507 19-19zM9 28c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15zm16-11a1 1 0 011 1v6.67l4.475-4.473a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-7.07 7.071c-.091.09-.188.17-.29.24A1.002 1.002 0 0125 31h-2a1 1 0 01-1-1V18a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconStopwatch',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
